module.exports = __webpack_public_path__ + "img/blik.235d39b.svg";